/**
 * List of available display languages that retailer or brand can choose from for chat
 */
export const HELP_CENTER_CHAT_AVAILABLE_LOCALES =
  'HELP_CENTER_CHAT_AVAILABLE_LOCALES';
